var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrepaga(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 82,
    viewBox: "0 0 82 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68.332 20.4999H58.082V13.6666C58.082 9.898 55.0173 6.83325 51.2487 6.83325H30.7487C26.9801 6.83325 23.9154 9.898 23.9154 13.6666V20.4999H13.6654C9.89678 20.4999 6.83203 23.5647 6.83203 27.3333V61.4999C6.83203 65.2685 9.89678 68.3333 13.6654 68.3333H68.332C72.1006 68.3333 75.1654 65.2685 75.1654 61.4999V27.3333C75.1654 23.5647 72.1006 20.4999 68.332 20.4999ZM30.7487 13.6666H51.2487V20.4999H30.7487V13.6666ZM13.6654 61.4999V27.3333H68.332L68.3354 61.4999H13.6654Z",
    fill: "#DA0067"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.4154 30.75H37.582V41H27.332V47.8333H37.582V58.0833H44.4154V47.8333H54.6654V41H44.4154V30.75Z",
    fill: "#DA0067"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrepaga);
export default __webpack_public_path__ + "static/media/prepaga.fea520fedeacfb9b0a2cd750f518ae41.svg";
export { ForwardRef as ReactComponent };